import { InferResponseType } from "hono";

import { HonoClient } from "~/hooks/HonoContext";
import {
  AccountSnapshot,
  CollectionSnapshot,
  InviteSnapshot,
  MemberSnapshot,
  SaveSnapshot,
  SpaceSnapshot,
  TagSnapshot,
} from "./store";

export function apiDataToStoreSnapshot(
  data: NonNullable<
    InferResponseType<HonoClient["account-dump"][":accountId"]["$get"]>["data"]
  >,
) {
  const { id, avatarUrl, displayName, slug, type, members, spaces, invites } =
    data;

  const out: AccountSnapshot = {
    id,
    avatarUrl,
    displayName,
    slug,
    type,
    members: members.reduce((acc: Record<string, MemberSnapshot>, member) => {
      acc[member.id] = member;
      return acc;
    }, {}),
    invites: invites.reduce((acc: Record<string, InviteSnapshot>, invite) => {
      acc[invite.id] = { ...invite, createdAt: new Date(invite.createdAt) };
      return acc;
    }, {}),
    spaces: spaces.reduce((acc: Record<string, SpaceSnapshot>, space) => {
      const collections = space.collections.reduce(
        (acc: Record<string, CollectionSnapshot>, collection) => {
          acc[collection.id] = collection;
          return acc;
        },
        {},
      );

      acc[space.id] = {
        ...space,
        tags: space.tags.reduce((acc: Record<string, TagSnapshot>, tag) => {
          acc[tag.id] = tag;
          return acc;
        }, {}),
        collections,
        saves: space.saveUrls.reduce(
          (acc: Record<string, SaveSnapshot>, save) => {
            const common = {
              id: save.id,
              createdAt: new Date(save.createdAt),
              updatedAt: save.updatedAt ? new Date(save.updatedAt) : null,
              type: save.type,
              meta: save.meta,
              collections: save.collectionSave.reduce((acc, cS) => {
                // @ts-expect-error ...
                acc[cS.collectionId] = cS.collectionId;
                return acc;
              }, {}),
              tags: save.tagSave.reduce((acc, tS) => {
                // @ts-expect-error ...
                acc[tS.tagId] = tS.tagId;
                return acc;
              }, {}),
              title: save.title ?? "",
              description: save.description ?? "",
            };
            if (save.type === "MEDIA") {
              acc[save.id] = {
                ...common,
                r2Key: save.r2Key ?? "",
                type: save.type,
              };
            }

            if (save.type === "FILE") {
              acc[save.id] = {
                ...common,
                r2Key: save.r2Key ?? "",
                type: save.type,
              };
            }

            if (save.type === "URL") {
              acc[save.id] = {
                ...common,
                type: save.type,
                url: save.url ?? "",
              };
            }
            if (save.type === "NOTE") {
              acc[save.id] = {
                ...common,
                type: save.type,

                richTextAST: (() => {
                  try {
                    return JSON.stringify(save.richTextAST);
                  } catch {
                    return JSON.stringify(null);
                  }
                })(),
              };
            }

            return acc;
          },
          {},
        ),
      };
      return acc;
    }, {}),
  };
  return out;
}
